package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Competence_criterion(
  public val id: String,
  public val competence_id: String,
  public val label: String,
  public val description: String?,
  public val level: Long,
  public val evaluated_at: Long?,
  public val evaluation_note: String?,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
